import Vue from 'vue'

declare module 'vue/types/vue' {
  interface Vue {
    $slack: (slackId: string) => string
  }
}

export default function SlackPlugin(V: typeof Vue) {
  V.prototype.$slack = function(slackId: string) {
    return `slack://channel?team=T0JE46RAN&id=${slackId}`
  }
}
